import { faPause } from "@fortawesome/pro-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { Typography } from "@mui/material"
import { translate } from "app/language/service"
import { IRootState, NOT_SAVED_ID } from "app/model"
import { CampaignStatus } from "campaign/components/misc/CampaignStatus"
import { CAMPAIGN_STATUSES } from "campaign/model"
import { FORM_SAVE_ERRORS, IForm } from "form/model"
import { isCreateForm } from "form/tools/common"
import React from "react"
import { connect } from "react-redux"
import { FlexBox } from "ui/components/FlexBox"
import { ChangeCount } from "./ChangeCount"

interface IFormLayoutHeaderConnectProps {
  contentWidth: number
}

interface IFormLayoutHeaderProps {
  isLoadingInitialData: boolean
  isLoadingForm: boolean
  hasInitialDataLoadingError: boolean
  saveError: FORM_SAVE_ERRORS | null
  status: CAMPAIGN_STATUSES | null
  form: IForm
  contentWidth: number
}

const FormLayoutHeaderFn = React.memo(
  ({
    isLoadingInitialData,
    isLoadingForm,
    hasInitialDataLoadingError,
    saveError,
    status,
    form,
    contentWidth
  }: IFormLayoutHeaderProps) => {
    if (isLoadingInitialData || isLoadingForm) {
      return null
    }
    const tempCampaignIsSaved = form.tempCampaignId !== NOT_SAVED_ID
    const isCreation = isCreateForm(form)
    const isForecastForm = form.context.isForecast
    const isDspDealForm = form.context.isDspDeal
    return (
      <FlexBox
        fullWidth
        jc="space-between"
        sx={{
          mt: contentWidth > 650 ? "1rem" : ".2rem",
          mb: contentWidth > 650 ? "1rem" : ".8rem",
          maxHeight: "4rem"
        }}>
        <FlexBox wrap gap>
          {contentWidth > 650 && (
            <Typography
              id="form-layout-header-title"
              sx={{
                fontSize: "1.4rem",
                fontWeight: 500,
                mr: "1rem",
                color: theme => theme.palette.text.primary2
              }}>
              {isCreation
                ? translate(
                    isForecastForm ? "forecast.new.name" : isDspDealForm ? "dsp-deal.new.name" : "campaign.new.name"
                  )
                : form.configuration.main.name}
            </Typography>
          )}
          {!isForecastForm && <CampaignStatus id="form-campaign-status" status={status} isDspDeal={isDspDealForm} />}
          {form.context.isPaused && (
            <FlexBox gap=".3rem" sx={{ "& .icon": { color: theme => theme.palette.primary.main } }}>
              <FontAwesomeIcon icon={faPause} className="icon" />
              <Typography
                id="form-is-paused"
                fontSize=".8rem"
                fontWeight={500}
                sx={{ color: theme => theme.palette.primary.main }}>
                {translate("label.paused")}
              </Typography>
            </FlexBox>
          )}
        </FlexBox>
        {!isLoadingInitialData && !hasInitialDataLoadingError && (
          <FlexBox gap>
            <ChangeCount form={form} sx={{ ml: "1rem" }} />
            {saveError && tempCampaignIsSaved && saveError === FORM_SAVE_ERRORS.SERVER && (
              <Typography color="error" sx={{ fontSize: ".7rem", ml: "1rem" }}>
                {translate("campaign.save.error.server")}
              </Typography>
            )}
          </FlexBox>
        )}
      </FlexBox>
    )
  }
)

export const FormLayoutHeader = connect(
  (state: IRootState): IFormLayoutHeaderConnectProps => ({
    contentWidth: state.ui.contentWidth
  })
)(FormLayoutHeaderFn)
